import { useCallback } from "react"
import { v4 as uuidv4 } from 'uuid';


export const useFormStructure = () => {

    // Рекурсивная функция для добавления уникального id к каждому элементу
  const assignUniqueIds = useCallback((structure) => {
    if (!structure) return;

    // Присваиваем уникальный id текущему элементу
    structure.id = uuidv4();

    // Если есть вложенные элементы (например, в Layout или Group), рекурсивно обрабатываем их
    if (Array.isArray(structure.elements)) {
      for (let element of structure.elements) {
        assignUniqueIds(element);
      }
    }
  }, [])


  // получаем свойства поля из shema по имени поля
  const getSchemaProperty = useCallback((schema, path) => {
    let current = schema;
    for (let part of path) {
      if (current && typeof current === 'object' && part in current) {
        current = current[part];
      } else {
        return undefined;
      }
    }
    return current;
  }, [])

  const getControlData = useCallback((data, fieldName) => {
    return data[fieldName];
  }, [])


  // рекурсивно обходим структуру формы, полученную из uiSchema. Для каждого Control вызываем getSchemaProperty
  const loadControlsPropertiesAndData = useCallback((structure, schema, data) => {
    if (!structure) return;

    // Если это элемент 'Control', добавляем свойства из schema
    if (structure.type === 'Control' && structure.scope) {
      // Парсим scope, удаляем "#/" и разбиваем на части
      const path = structure.scope.slice(2).split('/').filter(Boolean);
      const schemaProps = getSchemaProperty(schema, path);
      if (schemaProps) {
        // Добавляем свойства как 'schemaProps' в элемент, чтобы избежать конфликтов с существующими ключами
        structure.schemaProps = {
          ...schemaProps,
          filled: schemaProps.filled ?? 'lab'
        };
      }
      const initialData = getControlData(data, path.pop())
      if (initialData) {
        // Добавляем свойства как 'schemaProps' в элемент, чтобы избежать конфликтов с существующими ключами
        structure.initialData = initialData;
      }
    }

    // Если есть вложенные элементы (например, в Layout или Group), рекурсивно обрабатываем их
    if (Array.isArray(structure.elements)) {
      for (let element of structure.elements) {
        loadControlsPropertiesAndData(element, schema, data);
      }
    }
  }, [getSchemaProperty, getControlData])


  const createFormStructure = useCallback((uiSchema, schema, data) => {
    // Создаем глубокую копию uiSchema, чтобы не мутировать оригинал
    const formStructure = JSON.parse(JSON.stringify(uiSchema));
    
    // Сначала присваиваем уникальные id всем элементам
    assignUniqueIds(formStructure);

    // добавляем свойства элементов из schema
    loadControlsPropertiesAndData(formStructure, schema, data);

    return formStructure;
  }, [assignUniqueIds, loadControlsPropertiesAndData])


  return { 
    createFormStructure 
  }

}